// removed by extract-text-webpack-plugin
module.exports = {"h4":"src-styles----faq-module---h4---2geNX","faq_list":"src-styles----faq-module---faq_list---2rV1v","faq_item":"src-styles----faq-module---faq_item---3Mt6d","faq_item_inner":"src-styles----faq-module---faq_item_inner---3mGFq"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/faq.module.scss
// module id = 809
// module chunks = 51558153065178